import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderSupplyDetail extends BaseModelAPI {
	static entity = 'workordersupplydetail';
	static entityName = 'workordersupplydetail';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.workOrderSupplyId = '';
		this.workOrderSupply = {};
		this.partId = '';
		this.part = {};
		this.materialPartId = '';
		this.materialPart = {};
		this.workOrderProcessDetailId = '';
		this.workOrderProcessDetail = {};
		this.partName = '';
		this.billOfMaterialDetailId = '';
		this.billOfMaterialDetail = {};
		this.customerId = '';
		this.customer = {};
		this.qtyPlan = 0;
		this.qtyConsumption = 0;
		this.qtyTransit = 0;
		this.qtyStock = 0;
		this.qtySupply = 0;
		this.uomId = '';
		this.uom = {};
		this.remark = '';
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async generateWoSupplyDetail(this_, workOrderSupplyId) {
		return this_.$http.get(`${this.entityName}/generatewosupplydetail/${workOrderSupplyId}`)
			.then(result => {
				return result;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});;
	}

	static async recalculateQtyStock(this_, id, workOrderSupplyId) {
		return this_.$http.get(`${this.entityName}/recalculateqtystock/${id}?workordersupply=${workOrderSupplyId}`)
			.then(result => {
				return result;
			}).catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});;
	}
}